import React from 'react'
import './index.scss'
const DropDownMenu = (props) => {
  let { dropDownOptions = [], onSelect, nextSelection = '', dropStateOptions = [], DropDownName } = props

  return (
    <div className='drop-down-model-container'>

      <div className='drop-down-model-item-container'>
        {
          dropDownOptions && dropDownOptions.length >= 1 && dropDownOptions.map((item) => {
            return (
              <>
                {(DropDownName == 'species' && item.speciesUrl) || (DropDownName == 'huntTypes') ?
                  <div key={item.name} className='drop-menu-options' onClick={() => onSelect(item.name, nextSelection, item, { huntTypes: item.residency })}>
                    {DropDownName != "huntTypes" &&
                      <div style={{ width: '20%' }}>
                        <img src={item.speciesUrl}
                          // alt={'no i'}
                          className='drop-menu-icon' />
                      </div>}
                    <div style={{ width: DropDownName == "huntTypes" ? "90%" : '75%' }}>
                      <span className='drop-menu-text'>{item.name}</span>
                    </div>
                  </div>
                  : null}
              </>
            )
          }
          )

        }


        {
          dropStateOptions && dropStateOptions.length >= 1 && dropStateOptions.map((item) => (
            <div key={item.stateAbbr} className='drop-menu-options' onClick={() => onSelect(item.stateName, nextSelection, item, { returnSpaciesObject: item.species })}>
              {/* <img src={item.stateIconUrl} alt={`${item.stateName} icon`} className='drop-menu-icon' />
              <span className='drop-menu-text'>{item.stateName}</span> */}
              <div style={{ width: '20%' }}>
                <img src={item.stateIconUrl}
                  className='drop-menu-icon' />
              </div>
              <div style={{ width: '75%' }}>
                <span className='drop-menu-text'>{item.stateName}</span>
              </div>
            </div>
          ))

        }


      </div>
    </div>
  )
}

export default DropDownMenu
